//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Formboard.js";
import "../no/Object.js";
import "../no/ugmath.js";
import "../Routing/Routing.RouteManager.js";
let d=[[],[[[],"IsFormboard",{R_:{result:''}},0,0],[["harnesses"],"StoreHarnessesToFlatten",{},1,0],[["harness_part"],"AddPartAs3dHarness",{},1,0],[[],"CreateLayoutBuilder",{R_:{builder:"Formboard.FormboardLayoutBuilder"}},0,0],[[],"CreateOrientBranchBuilder",{R_:{builder:"Formboard.OrientBranchBuilder"}},0,0],[[],"CreateFlipComponentBuilder",{R_:{builder:"Formboard.FlipComponentBuilder"}},0,0],[["segment"],"CreateShapeSegmentBuilder",{R_:{builder:"Formboard.ShapeSegmentBuilder"}},1,0],[[],"CreateFaceAnnotationBuilder",{R_:{builder:"Formboard.FaceAnnotationBuilder"}},0,0],[[],"CreateObjectAttributeReferenceBuilder",{R_:{builder:"Formboard.ObjectAttributeReferenceBuilder"}},0,0],[["annotation"],"CreatePathLengthAnnotationBuilder",{R_:{builder:"Formboard.PathLengthAnnotationBuilder"}},1,0],[[],"CreateUpdateFormboardBuilder",{R_:{builder:"Formboard.UpdateFormboardBuilder"}},0,0],[["fmbdPlane","noOfConstraints","constraints"],"GetFmbdPlaneConstraints",{},1,0],[[],"ShowFormboardConstraints",{},0,0],[[],"HideFormboardConstraints",{},0,0],[["component1","component2","displayStyle","rotationVector","clockingAngle","confidenceLevel"],"CalculateLegacyComponentClocking",{},3,0]],[]];
SPLM.Formboard.FormboardManager = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Formboard.FormboardManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Formboard.FormboardManager.LegacyComponentOrientationDisplayStyle = Object.freeze({
    "NoDisplay" : "NoDisplay", "DisplayCurveNormals" : "DisplayCurveNormals", "DisplaySurface" : "DisplaySurface", "DisplayAll" : "DisplayAll"});

SPLM.Formboard.FormboardManager.LegacyComponentOrientationConfidenceLevel = Object.freeze({
    "High" : "High", "Medium" : "Medium", "Low" : "Low"});

export default SPLM;